<script>
import { defineComponent } from 'vue'
import PageArticle from '@v/tangFeedComponentFetch.vue'

export default defineComponent({
    components: {
        PageArticle,
    },
})

</script>